// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2Vu1Q","active":"NavigationItem_active__11NkN","Clickable":"NavigationItem_Clickable__2vFtd","Info":"NavigationItem_Info__1Kc2F"};